<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="toc"><b>Table of Contents</b></p>
<p class="center">___________________</p>
<p class="toc"><a href="#/Text/part1">The Hits of ’69!</a></p>
<p class="toc"><a href="#/Text/part2">Stereophrenia ’70!</a></p>
<p class="toc"><a href="#/Text/part3">Provocative Progressions '73</a></p>
<p class="toc"><span href="#/Text/part4" title="Link target outside of Sample">Vibrations ’74!</span></p>
<p class="toc"><span href="#/Text/part5" title="Link target outside of Sample">Autumn Contrasts '74</span></p>
<p class="toc"><span href="#/Text/part6" title="Link target outside of Sample">Sounds of ’75!</span></p>
<p class="toc"><span href="#/Text/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/Text/bio" title="Link target outside of Sample">About Michael Zadoorian</span></p>
<p class="toc"><span href="#/Text/copy" title="Link target outside of Sample">Copyright &amp; Credits</span></p>
<p class="toc"><span href="#/Text/akb" title="Link target outside of Sample">About Akashic Books</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4d4bbf0a